var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('content-link-edit',{attrs:{"content":_vm.content,"back-route":{ name: 'client-content-links', params: { clientId: _vm.clientId } }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/clients/client/content/links/edit.vue?vue&type=template&id=d17e562c
// module id = aIa9
// module chunks = 0